export interface INotification{
    id: string,
    text: string,
    type: NotificationType,
    autoDismiss: boolean
}

export enum NotificationType{
    Success = "success",
    Warning = "warning",
    Error = "danger",
    Info = "primary"
}